import React, { useEffect, useRef, useState } from 'react';
import { Users, Award, Clock } from 'lucide-react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" ref={sectionRef} className="about-section">
      <div className="about-container">
        <div className={`about-content ${isVisible ? 'visible' : ''}`}>
          <div className="section-header">
            <span className="section-badge">About Us</span>
            <h2 className="section-title">Your Trusted Cleaning Partner</h2>
          </div>
          <div className="about-grid">
            <div className="about-text">
              <p className="about-description">
                We are a cleaning company with over five years of experience in the industry, both in Europe and the United States. Our story began in Ukraine, but due to the events that took place there, we were forced to relocate to America. For more than a year, we worked in this field in the state of Kentucky before moving again. Now, we are rebuilding our business from scratch — but with extensive experience and a passion for excellence.
              </p>
              <p className="about-description">
                Thousands of satisfied clients in Europe and the U.S., our ability to handle any challenge, and a flexible work schedule have helped us earn our customers' trust. We are committed to maintaining the same high standards here. Trust us once, and you'll want to work with us forever.
              </p>
              <p className="about-description">
                If you need cleaning — <strong>A+ Crystal Clean.</strong>
              </p>
              <div className="about-stats">
                <div className="stat-item">
                  <Users className="stat-icon" size={32} />
                  <div className="stat-content">
                    <h3 className="stat-number">500+</h3>
                    <p className="stat-label">Happy Clients</p>
                  </div>
                </div>
                <div className="stat-item">
                  <Clock className="stat-icon" size={32} />
                  <div className="stat-content">
                    <h3 className="stat-number">5+</h3>
                    <p className="stat-label">Years Experience</p>
                  </div>
                </div>
                <div className="stat-item">
                  <Award className="stat-icon" size={32} />
                  <div className="stat-content">
                    <h3 className="stat-number">100%</h3>
                    <p className="stat-label">Satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-images">
              <div className="image-wrapper main-image">
                <img 
                  src="https://images.pexels.com/photos/9462732/pexels-photo-9462732.jpeg?w=600&h=800&fit=crop" 
                  alt="Professional cleaning team member"
                  className="about-img"
                />
                <div className="image-overlay"></div>
              </div>
              <div className="image-wrapper secondary-image">
                <img 
                  src="https://images.pexels.com/photos/6195285/pexels-photo-6195285.jpeg?w=400&h=500&fit=crop" 
                  alt="Cleaning professional with equipment"
                  className="about-img"
                />
                <div className="image-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
